let apiUrl = "https://apirus.suryapratamamart.com";
export default apiUrl